import {
    IS_GAMER_CARD_LOADING,
    GAMER_CARD_HAS_ERROR,
    GAMER_CARD_FETCH_DATA_SUCCESS,
    IS_SUBSCRIBE_LOADING,
    SUBSCRIBE_HAS_ERROR,
    SUBSCRIBE_FETCH_DATA_SUCCESS,
    IS_EDITORIAL_CARD_LOADING,
    EDITORIAL_CARD_FETCH_DATA_SUCCESS,
    EDITORIAL_CARD_HAS_ERROR,
    IS_DREAM_TEAM_LOADING,
    DREAM_TEAM_HAS_ERROR,
    DREAM_TEAM_SUCCESS,
    IS_EOS_LOADING,
    EOS_FETCH_DATA_SUCCESS,
    EOS_HAS_ERROR
} from './../constants/action-types';
import { gamerCardAPI, subscribeAPI, editorialCardAPI, dreamTeamAPI, eosUefacardAPI } from "../constants/api-url";
import config from './../config';
import common from './../common';

export function gamerCardFetchData() {
    let socialID = 0;
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
        if (parsedCookieGM) {
            socialID = parsedCookieGM.SocialId;
        }
    }
    let params = {
        optType: 1,
        clientId: 1,
        platformId: config.PLATFORM_ID,
        socialId: socialID,
        langCode: config.CURRENT_LANGUAGE
    };
    return (dispatch) => common.makeAPICall(gamerCardAPI, dispatch, isGamerCardLoading, gamerCardFetchDataSuccess, gamerCardHasError, params);
}

export function isGamerCardLoading(bool) {
    return {
        type: IS_GAMER_CARD_LOADING,
        payload: bool
    };
}

export function gamerCardFetchDataSuccess(data) {
    return {
        type: GAMER_CARD_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function gamerCardHasError(bool) {
    return {
        type: GAMER_CARD_HAS_ERROR,
        payload: bool
    };
}

// eos api call

export function eosFetchData() {
    let socialID = 0;
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
        if (parsedCookieGM) {
            socialID = parsedCookieGM.UefaSocialId;
        }
    }
    let params = {
        optType: 1,
        clientId: 1,
        platformId: config.PLATFORM_ID,
        socialId: socialID,
        langCode: config.CURRENT_LANGUAGE
    };
    return (dispatch) => common.makeAPICall(eosUefacardAPI, dispatch, isEosLoading, eosFetchDataSuccess, eosFetchDataHasError, params);
}

export function isEosLoading(bool) {
    return {
        type: IS_EOS_LOADING,
        payload: bool
    };
}

export function eosFetchDataSuccess(data) {
    return {
        type: EOS_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function eosFetchDataHasError(bool) {
    return {
        type: EOS_HAS_ERROR,
        payload: bool
    };
}
//eos end

export function postSubscribe(IsNewsletterP) {
    let socialID = Math.round(Math.random() * 100000);
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    let cookieGM = common.getCookie(COOKIE_GM);
    if (cookieGM) {
        parsedCookieGM = common.parseCookie(cookieGM);
        if (parsedCookieGM) {
            socialID = parsedCookieGM.SocialId;
        }
    }
    let params = {
        IsNewsletter: IsNewsletterP,
        ClientId: 1,
        PlatformId: config.PLATFORM_ID,
        SocialId: socialID,
    };
    return (dispatch) => common.makeAPICall(subscribeAPI, dispatch, isSubscribeLoading, subscribeDataSuccess, subscribeHasError, params, 'POST');
}

export function isSubscribeLoading(bool) {
    return {
        type: IS_SUBSCRIBE_LOADING,
        payload: bool
    };
}

export function subscribeDataSuccess(data) {
    return {
        type: SUBSCRIBE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function subscribeHasError(bool) {
    return {
        type: SUBSCRIBE_HAS_ERROR,
        payload: bool
    };
}

export function editorialCardFetchData() {
    let params = {
        language: config.CURRENT_LANGUAGE
    };
    return (dispatch) => common.makeAPICall(editorialCardAPI, dispatch, iseditorialCardLoading, editorialCardFetchDataSuccess, editorialCardHasError, params);
}

export function iseditorialCardLoading(bool) {
    return {
        type: IS_EDITORIAL_CARD_LOADING,
        payload: bool
    };
}

export function editorialCardFetchDataSuccess(data) {
    return {
        type: EDITORIAL_CARD_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function editorialCardHasError(bool) {
    return {
        type: EDITORIAL_CARD_HAS_ERROR,
        payload: bool
    };
}

export function isDreamTeamLoading(bool) {
    return {
        type: IS_DREAM_TEAM_LOADING,
        payload: bool
    };
}

export function dreamTeamHasError(bool) {
    return {
        type: DREAM_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function dreamTeamFetchDataSuccess(data) {
    return {
        type: DREAM_TEAM_SUCCESS,
        payload: data
    };
}

export function getDreamTeam(gamedayId) {
    const params = {
        optType: 1,
        gamedayId: gamedayId,
        language: config.CURRENT_LANGUAGE,
    };
    return (dispatch) => common.makeAPICall(dreamTeamAPI, dispatch, isDreamTeamLoading, dreamTeamFetchDataSuccess, dreamTeamHasError, params);
}


// WEBPACK FOOTER //
// ./src/actions/HomeActions.js